import React from 'react'
import View from '../../../View/components/View'
import { config } from '../../../../config/Structure'
import styled from 'styled-components'

const SubscriptionsTable = () => {
  return (
    <div>
      <TableHolder>
      <View componentName='subscriptions' config={config.subscriptions} />

      </TableHolder>
    </div>
  )
}

export default SubscriptionsTable



const TableHolder  = styled.div`
@media (max-width:767px){
  td:nth-child(2), td:nth-child(3) {
    display: inline-block;
    text-align: center;
  }
}

`